/**
 * The pages a signed-out visitor is allowed to stand on.
 *
 * Shared by middleware.ts and the API client: if the two disagree about this,
 * the client bounces the visitor off a page the middleware just sent them to.
 */
export const AUTH_ROUTES = ["/login"];

export function isAuthRoute(pathname: string): boolean {
  return AUTH_ROUTES.some((r) => pathname === r || pathname.startsWith(`${r}/`));
}
